import { render, staticRenderFns } from "./NavFooter.vue?vue&type=template&id=e8bedf4c&"
import script from "./NavFooter.vue?vue&type=script&lang=js&"
export * from "./NavFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports